<script>
    /* v-model container for form post element  */
    export default {
        name: "FormContainer",
        mixins : [__MIXIN__],
        data() {
            return Object.assign({}, __FORM__, {locale: window.locale});
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/FormContainer.vue